import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const ONLY_LETTER_NUMBER_DASH_UNDERSCORE = /[^A-Za-z0-9_-]/g;

const useQueryParam = (param: string, skipReplace?: boolean) => {
  const { search } = useLocation();
  return useMemo(() => {
    const rawParams = new URLSearchParams(search).get(param);
    if (skipReplace) return rawParams ?? undefined;
    return (
      rawParams?.replace(ONLY_LETTER_NUMBER_DASH_UNDERSCORE, '') || undefined
    );
  }, [search, param, skipReplace]);
};

export { useQueryParam };
